import React from 'react';

function MenuButton({ children, icon, compact = false, className = '', type = 'button', disabled = false, ...rest }) {
  const cls = `menu-btn${compact ? ' menu-btn--small' : ''} ${className}`.trim();
  return (
    <button type={type} className={cls} disabled={disabled} {...rest}>
      {icon && <span className="btn-icon">{icon}</span>}
      {!compact && <span className="btn-text">{children}</span>}
    </button>
  );
}

export default MenuButton;
